import styled from 'styled-components';
import {Text} from '@vizir-banking/banking-app-core/dist/layout';

export const Header = styled(Text)`
  font-size: 18px;
  margin-bottom: 30px;
`;
